import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7605
 *
 * @param {SvgIconProps} props - svg props
 */
export const DeleteIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M7.60093 4.20833V6.33333H8.32093V5.132C8.32093 4.9365 8.51453 4.77783 8.75293 4.77783H15.2441C15.4833 4.77783 15.6769 4.9365 15.6769 5.132V6.33333H16.4009V4.20833C16.4009 3.81733 16.0137 3.5 15.5353 3.5H8.46653C7.98813 3.5 7.60093 3.81733 7.60093 4.20833ZM20 6.68778C20 6.49228 19.8208 6.33361 19.6 6.33361H4.4C4.1792 6.33361 4 6.49228 4 6.68778V7.39611C4 7.59161 4.1792 7.75028 4.4 7.75028H5.6L7.1584 19.8309C7.1816 20.2063 7.5328 20.5003 7.9568 20.5003H16.0432C16.468 20.5003 16.8176 20.2063 16.8416 19.8309L18.4 7.75028H19.6C19.8208 7.75028 20 7.59161 20 7.39611V6.68778Z' fill={color}/>
        </SvgIcon>
    )
}

export default DeleteIcon
